import { createApiHandler } from './handler';

const orderRequests = {
  apiClient: null,
  path: '/franchises/order-requests',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async getByBranch(id, params) {
    try {
      const queryParams = new URLSearchParams();
      params.forEach(param => {
        if (param.name && param.value) {
          queryParams.append(param.name, param.value);
        }
      });

      const response = await this.apiClient.get(`${this.path}/branch/${id}?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async approve(id) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/approve`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async reject(id) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/reject`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default orderRequests;
